/** The colour band a vendor score falls in. `''` is "no score". */
export type ScoreBand = '' | 'poor' | 'average' | 'good' | 'excellent';

/**
 * Bands a 0–5 vendor score: ≤2 poor, ≤3 average, ≤4 good, above that excellent.
 *
 * Shared by the grid and the Excel export so a cell is never shaded one way on screen and another
 * way in the downloaded file.
 */
export function scoreBand(value: number | null): ScoreBand {
  if (value == null) return '';
  if (value <= 2) return 'poor';
  if (value <= 3) return 'average';
  if (value <= 4) return 'good';
  return 'excellent';
}
